import { useCompany } from "Components/Company/hooks/useCompany";
import { CollectionPath, db } from "Configs/firebase";
import { isScheduleResource, ScheduleResource } from "domain-entities";
import { collection } from "firebase/firestore";
import { useEffect } from "react";
import { createCollectionStore } from "Store/helpers/createCollectionStore";

export const useScheduleResources = createCollectionStore<ScheduleResource>({
	is: isScheduleResource,
	sort: (a: ScheduleResource, b: ScheduleResource) =>
		a.name.localeCompare(b.name),
});

export const useSubscribeToScheduleResources = () => {
	const companyId = useCompany((state) => state.item?.id);

	useEffect(() => {
		if (!companyId) return;

		const ref = collection(
			db,
			CollectionPath.SCHEDULES,
			companyId,
			CollectionPath.SCHEDULE_RESOURCES
		);

		return useScheduleResources.getState().subscribe(ref);
	}, [companyId]);

	useEffect(() => {
		return useScheduleResources.getState().reset;
	}, []);
};
